import { defineMessages, MessageDescriptor } from '@redbubble/next/intl';
import { ShippingMethod } from '../../types/cart/ShippingMethod';

export const messages = defineMessages({
  standardShippingLabel: {
    defaultMessage: 'Standard',
  },
  expressShippingLabel: {
    defaultMessage: 'Express',
  },
});

export const shippingMethodLabels: Record<ShippingMethod, MessageDescriptor> = {
  [ShippingMethod.Standard]: messages.standardShippingLabel,
  [ShippingMethod.Express]: messages.expressShippingLabel,
} as const;
